import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import Segment from '../../../../components/Segment';
import Logo from '../../components/Logo';
import Background from '../../components/Background';
import CardAdvisor from '../../components/CardAdvisor';

import Doge from '../../assets/doge.jpg';

import './style.scss';

const segment = new Segment();

class Advisors extends React.Component {
  state = {
    numAdvisors: _.random(4, 4),
  };

  componentWillMount() {
    const { isAuthenticated } = this.props;
    if (!isAuthenticated) {
      this.props.router.push({
        pathname: '/assessment',
      });
    }
  }

  handleClickAdvisor = advisor => {
    const {
      advisors,
      location: { state },
    } = this.props;

    segment.track('step6_selected_advisor', {
      id: advisor.id,
      email: advisor.email,
      first_name: advisor.first_name,
      last_name: advisor.last_name,
    });

    this.props.router.push({
      pathname: '/assessment/booking',
      state: {
        ...state,
        advisors,
        advisor,
      },
    });
  };

  getHeading() {
    const { advisors } = this.props;
    return (
      <div className="advisors__heading">
        Based on your goals, we found {advisors ? advisors.length : 'no'}{' '}
        advisors who could be a great fit!
      </div>
    );
  }

  getCardAdvisor(advisor) {
    if (advisor) {
      const {
        id,
        first_name: firstName,
        last_name: lastName,
        linkedin_username: linkedinUsername,
        industries,
        advisor_info: advisorInfo,
        photo,
      } = advisor;
      // console.log(name);
      const { wistia, position, company, degree, university } = advisorInfo;
      const expertise = industries.map(industry => industry.name);

      // TODO: this should not be hardcoded
      const imgSrc = photo
        ? '//paragonone-paragon-photo-management-photo-cache-prod.paragonone.com/300x300/' +
          photo
        : Doge;

      return (
        <CardAdvisor
          key={id}
          advisor={advisor}
          image={<img src={imgSrc} alt={`${firstName} ${lastName}`} />}
          wistiaId={wistia}
          name={`${firstName} ${lastName}`}
          linkedinUsername={linkedinUsername}
          position={position}
          company={company}
          degree={degree}
          university={university}
          expertise={expertise}
          onClick={() => this.handleClickAdvisor(advisor)}
        />
      );
    }
  }

  getAdvisors() {
    const advisorCards = [];
    const { advisors } = this.props;
    // const advisors = _.slice(ADVISORS, 0, this.state.numAdvisors);

    if (advisors) {
      advisors.forEach(advisor => {
        advisorCards.push(this.getCardAdvisor(advisor));
      });
    }

    return <div className="advisors__cards">{advisorCards}</div>;
  }

  render() {
    return (
      <div>
        <Background />
        <Logo />
        <div className="assessment__wrapper">
          {this.getHeading()}
          {this.getAdvisors()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const advisors = _.get(ownProps, 'location.state.advisors');
  return {
    authedUser: _.get(state, 'auth.User'),
    isAuthenticated: !!_.get(state, 'auth.sub'),
    advisors,
  };
};

const mapDispatchToProps = {};

export default store => ({
  path: 'advisors',
  component: connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Advisors),
});



// WEBPACK FOOTER //
// ./src/routes/assessment/routes/Advisors/index.js